/* eslint-disable no-prototype-builtins */
import './login.scss';
import { useNavigate } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';

import LoginForm from '../../../shared/forms/login-form';
import useUserLogin from '../../../../utilities/hooks/useUserLogin';
import useResendSignUp from '../../../../utilities/hooks/useResendSignUp';

const Login = () => {
  const navigate = useNavigate();

  const [showResetMessage, setShowResetMessage] = useState(false);
  const [showAccountVerifiedMessage, setShowAccountVerifiedMessage] =
    useState(false);
  const [emailVerificationResent, setEmailVerificationResent] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);
  const verify = queryParams?.get('verify');
  const verified = queryParams?.get('verified');
  const redirectUrl = queryParams?.get('uri');

  const { error: loginError, login, isLoading } = useUserLogin();
  const { resendSignup } = useResendSignUp();

  useEffect(() => {
    if (redirectUrl) {
      navigate('/login?redirect=true');
    }
    if (verified) {
      setShowAccountVerifiedMessage(true);
    }
    if (verify) {
      navigate(`/confirm-signup?verify=${verify}`);
    }
    if (sessionStorage.getItem('resetPassword') === 'true') {
      sessionStorage.removeItem('resetPassword');
      setShowResetMessage(true);
    }
  }, [navigate, redirectUrl, verified, verify]);

  const handleLogin = useCallback(
    (formValues) => {
      login(formValues, {
        onSuccess: () => {
          if (redirectUrl) {
            navigate(redirectUrl);
          } else {
            navigate('/');
          }
        },
      });
    },
    [navigate, login, redirectUrl],
  );

  const handleVerify = useCallback(
    (verificationEmail) => {
      resendSignup(verificationEmail, {
        onSuccess: () => {
          setEmailVerificationResent(true);
        },
      });
    },
    [resendSignup],
  );

  return (
    <div className="login-page">
      <LoginForm
        onSubmit={handleLogin}
        onVerify={handleVerify}
        isLoading={isLoading}
        error={loginError}
        emailVerificationResent={emailVerificationResent}
        showAccountVerifiedMessage={showAccountVerifiedMessage}
        showResetMessage={showResetMessage}
      />
    </div>
  );
};

export default Login;
